import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';
import { validationInputProps } from "../../../utils/inputValidation";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CreateEmpresas from "../../clientes/Empresas/Create.js"


import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaContacto: new Date(),
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.contactos.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Contacto ha sido creado con éxito."}
                title={"Nuevo Contacto"}
                buttonTitle={"Nuevo Contacto"}
                buttonIcon={"fa fa-plus fa-lg"}
                className={"ui-modal-dialog"}
                saveButton={true}
                closeButton={true}>
                <div className="ui-form">
                    <p className="ui-section-label">Datos del contacto</p>
                    <div className="ui-row-2">
                        <div className="ui-field">
                        <Label>Fecha de Contacto</Label>
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'fechaContacto', className: 'form-control' }}
                            value={this.state.fechaContacto}
                            onChange={(e) => this.setState({ fechaContacto: e._d })}
                        />
                        </div>
                        <div className="ui-field">
                        <Label>Empresa/Organización</Label>
                        <ParadigmaAsyncSeeker Create={CreateEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                    <div className="ui-row-2">
                        <div className="ui-field">
                        <Label>Email</Label>
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                        <div className="ui-field">
                        <Label>Teléfono</Label>
                        <Input type="text" name="telefono" ></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                        <Label>Observaciones</Label>
                        <Input rows={10} type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento0/Create.js